import React, { useEffect, useState } from "react";

import { Container } from "react-bootstrap";
import 'swiper/css';
import 'swiper/css/pagination';
import "../../../assets/styles/pages/homeCss/counter.css";
import hearts from "../../../assets/images/homeImages/CounterImg/Group (1).svg";
import CountUp from 'react-countup';
import AOS from 'aos'

const Counter = () => {
  const [count1, setcount1] = useState(0)
  const [count2, setcount2] = useState(0)
  const [count3, setcount3] = useState(0)

  useEffect(() => {
    AOS.init({ duration: 2000, },);




  }, [])

  const counterRun = (event) => {
    console.log(event)
    setcount1(80)
    setcount2(45)
    setcount3(255)


  }
  // const counterStope=()=>{
  //   setcount1(0)

  // }


  return (
    <section className="counter-section" onMouseOver={(event) => counterRun(event)} >
      <Container fluid>
        <div className=" counter-main">
          <div className="row">
            <div className="col-md-6 col-lg-6 col-sm-6 " data-aos='fade-right'>
              <div className="heart-head">
                <div className="ms-auto">
                  <img src={hearts} alt="" />
                </div>
                <div>

                  <p className="counter-p-head mt-3 ">
                    Your Employee <br /> Portal for Health <br /> & Happiness
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-6 ms-auto" data-aos='fade-left'>
              <div className="row  ">

                <div className="col-md-6 col-sm-12 col-lg-4">

                  <div className="counter-num1  ">
                    <p className="counter-p">
                      <CountUp end={count1} duration={7} />+
                    </p>

                    <div className="text-secondary"> World class coaches</div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-4">
                  <div className="counter-num2 ">
                    <p className="counter-p">
                      <CountUp end={count2} duration={7} />  +
                    </p>

                    <div className="text-secondary"> Wellness categories</div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-12 col-lg-4">
                  <div className="counter-num3 ">
                    <p className="counter-p">
                      <CountUp end={count3} duration={5} />
                    </p>



                    <div className="text-secondary"> Live and on-demand events</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Counter;
